<svelte:options
  customElement={{
    tag: 'column-fetch',
    props: {
      category: { type: 'String' },
      limitnumber: { type: 'Number' },
      customarray: { type: 'String' }
    }
  }}
/>

<script>
  import { onMount } from 'svelte';
  import { api } from '@util/Fetch';

  let { category = '', limitnumber = 4, customarray = '' } = $props();

  let posts = $state([]);
  // let filterPosts = $state([]);
  let loading = $state(true);
  let error = $state(null);

  const custom = $derived.by(() => {
    if (customarray) {
      try {
        const targetList = JSON.parse(customarray);
        const targetTitles = targetList.map(item => item.title);
        // jsonデータの中から、customarrayに含まれるタイトルを持つものを抽出
        return targetTitles.map(title =>
          posts.find(post => post.title === title)//customarrayの順番を維持
        ).filter(Boolean); // 見つからなかった要素を除外
      } catch (e) {
        console.error('JSON parse error in customarray:', e);
        return [];
      }
    }

    // categoryが空なら全件、入っていればフィルタ
    const filtered = category ? posts.filter((i) => i.category === category) : posts;

    return filtered.slice(0, limitnumber);
  });

  async function fetchPosts() {
    loading = true;
    try {
      const data = await api.get('/assets_default/data/column.json');
      // データを 'date' の値で最新順（降順）に並べ替える
      posts = data.sort((a, b) => new Date(b.date) - new Date(a.date));
    } catch (e) {
      error = e.message;
    } finally {
      loading = false;
    }
  }

  onMount(() => {
    fetchPosts();
  });
</script>

  {#if loading}
    <p class="owd-text:01 align:center spacing:bottom:24">Loading posts...</p>
  {:else if error}
    <!-- エラーが発生した場合に表示 -->
    <p class="owd-text:01 align:center spacing:bottom:24">エラーが発生しました: {error}</p>
  {:else if custom.length > 0}
    <!-- データがある場合にリストとして表示 -->
    <ul class="owd-card-wrap:column:2 spacing:bottom:32">
      {#each custom as post,index}
        <li class="owd-card">
          <a href={post.link}>
            <img class="spacing:bottom:8" src="{post.thumbnail}" width="163" height="109" alt="ダミー" >
            <div class="owd-sub owd-sub:small spacing:bottom:8">
              <span class="owd-sub-marker"></span>
              <p class="owd-information">{post.label}</p>
            </div>
            <h2 class="owd-text:02 align:left spacing:bottom:16"><strong>{post.title}</strong></h2>
            <ul class="owd-card-tagarea">
              {#each post.hashtag as tag}
                <li class="owd-information font-adjust">#{tag}</li>
              {/each}
            </ul>
          </a>
        </li>
      {/each}
    </ul>
  {:else}
    <!-- データがない場合に表示 -->
    <p class="owd-text:01 align:center spacing:bottom:24"><strong>記事が見つかりませんでした。</strong></p>
  {/if}

    <div class="block:center">
      <a href="/column/" class="owd-button owd-button:large owd-button:secondary:white">コラム記事を見る</a>
    </div>




  <style lang="scss">
    @use "../../style/fondation";
    @use "../../style/components/card";
    @use "../../style/components/button";
    @use "../../style/elements/typography";
    @use "../../style/utils/utility";

  </style>
